export default "__VITE_ASSET___8UAnA33__"